export const permissionsKeys = {
  page: 'micro-sites.press-room.page-block',
  pageBlockFind: 'micro-sites.press-room.page-block.find',
  pageBlockCreateDefault: 'micro-sites.press-room.page-block.createDefault',
  pageBlockUpdate: 'micro-sites.press-room.page-block.update',
  pageBlockPreview: 'micro-sites.press-room.page-block.preview',
  pageBlockUpdateInactivate: 'micro-sites.press-room.inactivate.page-block.update',
  pageBlockUpdateActive: 'micro-sites.press-room.active.page-block.update',
  pageBlockRemove: 'micro-sites.press-room.page-block.remove',
};
